import { Alert, Col, Form, Icon, Layout, Menu, Row, Tabs, Typography } from 'antd';
import { FormComponentProps } from 'antd/lib/form';
import React from 'react';
import { ChangePasswordV2 } from '../profile/ChangePasswordV2';
import CommonTypeProps from '../../../common/CommonTypeProps';
import { LinkO2O } from '../../../common/LinkO2O';
import DashboardPageLayoutV2 from '../../../layout/dashboard/DashboardPageLayoutV2';

interface IChangePasswordComponentProps extends FormComponentProps, CommonTypeProps {
  changePwd: any;
}

export const ChangePasswordComponentV2 = Form.create<IChangePasswordComponentProps>()(
  (props: IChangePasswordComponentProps) => {
    const renderContentLayout = (version?: string) => {
      return (
        <>
          {version === 'v2' && (
            <Tabs
              defaultActiveKey='security'
              onChange={(key: string) => {
                if (key === 'my-profile') props.history.push({ pathname: '/my-account-info' });
                if (key === 'security') props.history.push({ pathname: '/security/2fa-security' });
                if (key === 'activity') props.history.push({ pathname: '/activity/invitation' });
              }}
            >
              <Tabs.TabPane tab='My Profile' key='my-profile' />
              <Tabs.TabPane tab='Security' key='security' />
              <Tabs.TabPane tab='Activity' key='activity' />
            </Tabs>
          )}
          <Layout>
            <Layout.Sider
              width={200}
              style={{ background: '#fff' }}
              className={version === 'v2' ? 'main-menu-v3 menu-connection' : ''}
            >
              <Menu mode='inline' defaultSelectedKeys={['change-password']} style={{ height: '100%' }}>
                <Menu.Item key='sercurity'>
                  <LinkO2O {...props} to={{ pathname: '/security/2fa-security' }}>
                    Two-Factor Auth
                  </LinkO2O>
                </Menu.Item>
                <Menu.Item key='change-password'>
                  <LinkO2O {...props} to={{ pathname: '/security/change-password' }}>
                    Change Password
                  </LinkO2O>
                </Menu.Item>
                <Menu.Item key='api'>
                  <LinkO2O {...props} to={{ pathname: '/security/my-account-api' }}>
                    API Account
                  </LinkO2O>
                </Menu.Item>
                <Menu.Item key='tokens'>
                  <LinkO2O {...props} to={{ pathname: '/security/my-account-tokens' }}>
                    Token
                  </LinkO2O>
                </Menu.Item>
              </Menu>
            </Layout.Sider>
            <Layout.Content style={{ overflow: 'hidden' }} className='pl30 pt10'>
              <Row type='flex' gutter={[10, 0]}>
                <Col xs={24}>
                  <Typography.Title level={4}>Change Password</Typography.Title>
                </Col>

                {props.authen.changePasswordReason ? (
                  <Col xs={24}>
                    <Alert
                      message=''
                      description={props.authen.changePasswordReason || 'Change Password Reason'}
                      type='error'
                      showIcon
                      icon={<Icon type='warning' />}
                    />
                  </Col>
                ) : null}

                <Col md={24} lg={14}>
                  <ChangePasswordV2
                    loading={props.ui.isLoading}
                    locale={props.locale}
                    orgCtx={props.user.orgCtx}
                    wrappedComponentRef={(propsRef: any) => { }}
                    user={props.user}
                    changePwd={props.changePwd}
                    commonActionFromDAL={props.commonActionFromDAL}
                    commonActionFromDALV2={props.commonActionFromDALV2}
                    history={props.history}
                  />
                </Col>
              </Row>
            </Layout.Content>
          </Layout>
        </>
      );
    };

    return (
      <DashboardPageLayoutV2
        props={props}
        selectedLeftNavStandard='my-security'
        selectedSubMenuStandard='my-security'
        selectedLeftNavModern='my-info'
        selectedSubMenuModern='my-info'
        breadcrumbItemsStandard={[
          { title: 'Home', path: '/' },
          { title: 'Security', path: '/security/2fa-security' },
          { title: 'Change Password' },
        ]}
        breadcrumbItemsModern={[
          { title: 'Account', path: '/' },
          { title: 'Profile', path: '/security/2fa-security' },
          { title: 'Security' },
        ]}
        pageTitle='Profile'
        renderContentLayout={renderContentLayout}
        metaTitle={props.ui.meta.title}
        pageTitleIcon={
          <Icon
            component={() => (
              <svg width='16' height='17' viewBox='0 0 16 17' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path
                  d='M2.46644 16.3333H13.5335C14.8691 16.3333 15.5 15.9188 15.5 15.0228C15.5 12.7695 12.6476 9.53332 7.99663 9.53332C3.35234 9.53332 0.5 12.7695 0.5 15.0228C0.5 15.9188 1.13087 16.3333 2.46644 16.3333ZM2.13758 15.2167C1.80873 15.2167 1.68792 15.1298 1.68792 14.8891C1.68792 13.3311 3.96308 10.6566 7.99663 10.6566C12.0369 10.6566 14.3121 13.3311 14.3121 14.8891C14.3121 15.1298 14.1913 15.2167 13.8624 15.2167H2.13758ZM8.01003 8.39661C10.0436 8.39661 11.6812 6.61134 11.6812 4.39816C11.6812 2.22508 10.0436 0.5 8.01003 0.5C5.98322 0.5 4.33221 2.25183 4.33221 4.41153C4.33221 6.61803 5.9765 8.39661 8.01003 8.39661ZM8.01003 7.27998C6.64764 7.27998 5.52013 6.02295 5.52013 4.41153C5.52013 2.84691 6.64093 1.61662 8.01003 1.61662C9.37917 1.61662 10.4933 2.82686 10.4933 4.39816C10.4933 6.00958 9.3725 7.27998 8.01003 7.27998Z'
                  fill='currentColor'
                />
              </svg>
            )}
          />
        }
      />
    );
  }
);
